import EducationProgramList from "./components/List"
import EducationProgramForm from "./components/Form"

let module = "educationprograms"

export default [
  { path: "educationprograms", component: EducationProgramList, meta: { module: module, permissions: ["educationprogram-access"] } },
  {
    path: "educationprograms/create",
    component: EducationProgramForm,
    props: true,
    meta: { module: module, permissions: ["educationprogram-create"] }
  },
  {
    path: "educationprograms/edit/:id",
    component: EducationProgramForm,
    props: true,
    meta: { module: module, permissions: ["educationprogram-edit"] }
  }
]
